import CreateCustomStrategyItem from "features/configuration/GeneralConfiguration/ConfigurationItem/StrategyItem/CreateCustomStrategyItem";
import ListStrategyItem from "features/configuration/GeneralConfiguration/ConfigurationItem/StrategyItem/ListStrategyItem";
import { useConfigurationItem } from "features/configuration/GeneralConfiguration/ConfigurationItem";
import { useContext } from "react";
import { StrategyItemContext } from "features/configuration/GeneralConfiguration/generalConfigurationContexts";
import { OrderTypes } from "@shared/types";
import BotStrategiesProvider from "@shared/features/bots/BotForm/Strategies/BotStrategiesProvider";
import { StrategyTabs } from "@shared/features/bots/BotForm/common/types";
import BotBaseStrategiesProvider from "@shared/features/bots/BotForm/Strategies/BotBaseStrategiesProvider";

const StrategyItem = ({ item, ...props }) => {
  const {
    handleSelectItem,
    handleDeleteItem,
    setEditOrCreateCustomStrategyItem,
    checkItemSelected,
    editOrCreateCustomStrategyItem,
    setItemToEdit,
  } = useContext(StrategyItemContext)!;
  // @ts-ignore
  const { itemValue, itemName } = useConfigurationItem({ item });

  return editOrCreateCustomStrategyItem ? (
    <BotBaseStrategiesProvider orderType={OrderTypes.ENTRY}>
      <BotStrategiesProvider
        selectedTab={StrategyTabs.CUSTOM}
        tab={StrategyTabs.CUSTOM}
        orderType={OrderTypes.ENTRY}
        createCustomStrategyTemplate={editOrCreateCustomStrategyItem}
        includeNameSelect={true}
        customStrategies={props.customStrategies}
        shouldInitializeTargets={!props.targets}
      >
        <CreateCustomStrategyItem {...props} />
      </BotStrategiesProvider>
    </BotBaseStrategiesProvider>
  ) : (
    <ListStrategyItem
      item={item}
      itemValue={itemValue}
      itemName={itemName}
      itemSelected={checkItemSelected(item)}
      handleSelectStrategy={() => handleSelectItem(item)}
      handleDeleteItem={handleDeleteItem}
      setEditOrCreateStrategyItem={setEditOrCreateCustomStrategyItem}
      setItemToEdit={setItemToEdit}
      hideEditAndRemove={props.hideEditAndRemove}
    />
  );
};

export default StrategyItem;
